// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "./assets/css/pydating.css?updateTime=202601021923";
import App from './App';
import router from './router';

// 引入请求工具
import request from '@/utils/request';
import comutil from '@/utils/comutil';
Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */
// 挂载到Vue原型上，方便组件内使用
Vue.prototype.$http = request
Vue.prototype.$com = comutil
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js